import { Section } from "@app/core/match/domain/model/section";
import { Section as SectionV2 } from "@app/core/match/domain/model/section.v2";
import { StatisticsGroup } from "@app/core/statistics/domain/model/statistics-group";

export enum StatisticsStatus {
  IN_PROGRESS = "in-progress",
  OK = "ok",
}

export interface StatisticsParams {
  status: StatisticsStatus;
  group?: StatisticsGroup[];
  totalClubs?: number;
  totalMatches?: number;
  avg_victories?: number;
  stats?: Section[];
  stats_v2?: SectionV2[];
}

export class OldStatistics {
  public readonly status: StatisticsStatus;
  public readonly group: StatisticsGroup[];
  public readonly totalClubs?: number;
  public readonly totalMatches?: number;
  public readonly avg_victories?: number;
  constructor(params: StatisticsParams) {
    this.status = params.status;
    this.totalClubs = params.totalClubs;
    this.totalMatches = params.totalMatches;
    this.group = params.group!;
    this.avg_victories = params.avg_victories;
  }
}


export class Statistics {
  public readonly status: StatisticsStatus;
  public readonly totalMatches?: number;
  public readonly stats?: Section[];
  public readonly stats_v2?: SectionV2[];
  constructor(params: StatisticsParams) {
    this.status = params.status;
    this.stats = params.stats!;
    this.stats_v2 = params.stats_v2!;
    this.totalMatches = params.totalMatches;
  }
}
